import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const Count = ({ to, suffix = "", className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1400;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {n}
      {suffix}
    </span>
  );
};

const STATS = [
  { node: <Count to={100} suffix="%" className="text-gold-gradient" />, label: "Focus on serious, paid-only clients" },
  { node: <Count to={5} suffix="+" className="text-gold-gradient" />, label: "Trading disciplines coached 1-on-1" },
  { node: <span className="text-gold-gradient">1:1</span>, label: "Private, direct access to Shabz" },
  { node: <span className="text-gold-gradient">6-Fig</span>, label: "Traders ready to break the plateau" },
];

export const Proof = () => (
  <section className="relative border-t border-white/10 bg-[#0c0c0d] py-20 sm:py-24">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-12 px-6 sm:px-8 lg:grid-cols-4 lg:px-12">
      {STATS.map((s, i) => (
        <Reveal key={i} delay={i * 0.1}>
          <div data-testid={`stat-${i}`} className="flex flex-col gap-3 lg:border-l lg:border-white/10 lg:pl-8">
            <span className="font-['Playfair_Display'] text-5xl font-semibold sm:text-6xl">
              {s.node}
            </span>
            <span className="max-w-[16rem] text-sm leading-relaxed text-[#a1a1aa]">{s.label}</span>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
